import { render, staticRenderFns } from "./DashboardFibuFixErrors.vue?vue&type=template&id=1a46f646&"
import script from "./DashboardFibuFixErrors.vue?vue&type=script&lang=ts&"
export * from "./DashboardFibuFixErrors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports